"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserEmployeeWarnings = void 0;
const user_details_1 = require("@app/reducer/user-details");
const store_1 = require("@app/store");
const user_employee_warnings_1 = require("../../request/user-employee-warnings");
const employee_card_context_1 = require("../employee-card-context");
const useEmployeeCardData_1 = require("./useEmployeeCardData");
const useUserEmployeeWarnings = () => {
    const { workspace, userId } = (0, employee_card_context_1.useEmployeeCard)();
    const dispatch = (0, store_1.useRootDispatch)();
    const { data } = (0, useEmployeeCardData_1.useEmployeeCardData)({
        actionName: 'user-employee-warnings',
        requestor: async () => await (0, user_employee_warnings_1.requestUserEmployeeWarnings)({
            workspaceId: workspace?.id ?? '',
            userId: userId ?? '',
        }),
        reducer: (data) => dispatch((0, user_details_1.setUserEmployeeWarnings)(data?.employeeWarnings)),
        selector: (state) => state.userDetails.employeeWarnings,
        listenDeps: [workspace?.id, userId],
    });
    return data;
};
exports.useUserEmployeeWarnings = useUserEmployeeWarnings;
